import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


//设备列表
export async function getDeviceList(params) {
    return post(erpserver+'/deviceLedger/selectDeviceList', params, true);
}
//动态属性
export async function getConfigColumn(params) {
    return post(erpserver+'/deviceLedger/getConfigColumn', params, true);
}
//设备详情
export async function getDeviceLedgerDetail(params) {
    return post(erpserver+'/deviceLedger/getDeviceLedgerDetail', params, true);
}
//字典表 状态\类型
export async function getDeviceDict(params) {
    return post(erpserver+'/deviceLedger/getDeviceDict', params, true);
}
//负责人列表
export async function getPrincipalList(params) {
    return post(erpserver+'/deviceLedger/getPrincipalList', params, true);
}
//保存
export async function updateDeviceLedger(params) {
    return post(erpserver+'/deviceLedger/updateDeviceLedger', params, true);
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}